import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Unauthorized from "./pages/Unauthorized";
import Login from "./pages/Auth/Login";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FeedbackProvider } from "./context/FeedbackContext";
import AdminLayout from "./layouts/AdminLayout";
import { ReactQueryProvider } from "./lib/react-query";

// Protected route wrapper component
const ProtectedAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <ReactQueryProvider>
      <AuthProvider>
        <FeedbackProvider>
          <Router>
            <Routes>
              {/* Authentication Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Admin Routes - Protected */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedAdminRoute>
                    <AdminLayout />
                  </ProtectedAdminRoute>
                }
              />

              {/* Unauthorized Access */}
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Default Route - Redirect to dashboard if authenticated, login otherwise */}
              <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />

              {/* 404 Route */}
              <Route path="*" element={<h1 className="text-center mt-20">404 - Page Not Found</h1>} />
            </Routes>
          </Router>
        </FeedbackProvider>
      </AuthProvider>
    </ReactQueryProvider>
  );
};

export default App;

